import { VillagerMetaDataStyles } from './VillagerMetaData.types'

const makeStyles = (): VillagerMetaDataStyles => ({
	villagerBirthday: {
		marginBottom: '5px'
	},
	villagerFamily: {
		marginTop: '25px'
	},
	villagerModalHeader: {
		fontSize: '28px'
	},
	zeroMargin: {
		margin: 0
	}
})

export default makeStyles
